import {Component, Input} from '@angular/core';
import {CatalogRecord} from '@raven';

@Component({
  selector: 'rn-list-item',
  templateUrl: './list-item.component.html',
  styleUrl: './list-item.component.scss',
  standalone: false
})
export class ListItemComponent {

  @Input() catalogRecord: CatalogRecord;
  @Input() topBorder: boolean;
}
